import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SIGN_USE_MONORAIL_SOA_ENDPOINT = createFcmDetails('sign_use_monorail_soa_endpoint', {
	owner: 'Site Platform',
	context: 'Signature API call from corgi to monorail',
	description: `
		Toggles monorail signature API calls to use the new /soa endpoint.

		Related to https://change.atlassian.net/browse/CHANGE-77227
	`,
	import: false,
});
